import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserSpacePortGame from '../../games/SpacePortGame/Main';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(XraySliderGame)'
interface SpacePortGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface SpacePortGameState {
}

class SpacePortGame extends React.Component<SpacePortGameProps, SpacePortGameState> {
    constructor(props: SpacePortGameProps) {
        super(props);
        bindAllOfThis(this, SpacePortGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserSpacePortGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default SpacePortGame;



// WEBPACK FOOTER //
// ./src/pages/game/SpacePortGame.tsx